import { makeAutoObservable } from 'mobx';
import ListType from '../interfaces/ListType';

export default class ListStore {
    type: ListType | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    toggleDeals() {
        this.toggleType(ListType.Deals);
    }

    toggleLeads() {
        this.toggleType(ListType.Leads);
    }

    toggleLeaseComps() {
        this.toggleType(ListType.LeaseComps);
    }

    toggleSaleComps() {
        this.toggleType(ListType.SaleComps);
    }

    toggleCompanies() {
        this.toggleType(ListType.Companies);
    }

    toggleTenantsInMarket() {
        this.toggleType(ListType.TenantsInMarket);
    }

    toggleFavorites() {
        this.toggleType(ListType.Favorites);
    }

    toggleNotifications() {
        this.toggleType(ListType.Notifications);
    }

    toggleType(type: ListType) {
        this.type = this.type === type ? null : type;
    }

    setType(type: ListType) {
        this.type = type;
    }

    close() {
        this.type = null;
    }

    clear() {
        this.close();
    }
}